import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Layout, Avatar, Typography, Button, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import useAuthContext from '../../contexts/AuthContext';
import NavMenuSiderRight from './NavMenuSiderRight';
import { LogoutButton } from '../../utils/constants/customButton';
import useErrorMessage from '../../utils/ErrorMessage';

const { Sider } = Layout;

const StyledSiderRight = styled.div`
  height: 100%;
  z-index: 10;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  overflow-x: hidden;
  position: fixed;
  right: 0;
`;
const StyledHeaderWelcome = styled.div`
  font-family: Oswald;
  text-align: center;
  padding: 8px 8px 0px 8px;
  height: 70px;
  border-bottom: 1px solid rgba(249, 249, 249, 0.5);

  @media (max-width: 992px) {
    padding: 5px 6px;
    overflow: hidden;
  }
`;
const StyledHeaderAvatar = styled.div`
  text-align: center;
  margin-top: 2em;
`;

const RightSider = ({ path, setCollapsed, collapsed }) => {
  const { dispatchAPI, user } = useAuthContext();
  const { message } = useErrorMessage();
  const [imageUrl, setImageUrl] = useState();
  const [isLogoLoading, setIsLogoLoading] = useState(true);

  const isReductScreen = useMediaQuery({ query: '(max-width: 992px)' });

  const getLogo = async (id) => {
    setIsLogoLoading(true);
    try {
      const result = await dispatchAPI('GET', {
        responseType: 'blob',
        url: `/insurers/avatar/${id}`
      });
      setImageUrl(URL.createObjectURL(result.data));
    } catch (e) {
      message(e);
    }
    setIsLogoLoading(false);
  };

  useEffect(() => {
    if (user?.insurer?.logo) {
      (async () => {
        await getLogo(user.insurer._id);
      })();
    }
    // eslint-disable-next-line
  }, [user?.insurer]);

  return (
    <>
      <StyledSiderRight
        as={Sider}
        width={200}
        breakpoint="lg"
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        {user?.insurer && (
          <>
            <StyledHeaderWelcome>
              <Typography.Paragraph
                style={{
                  display: isReductScreen || collapsed ? 'none' : 'block',
                  color: 'var(--textColorSecondary)',
                  marginBottom: '.5em'
                }}
              >
                Bienvenue
              </Typography.Paragraph>
              <Typography.Text
                style={{
                  color: 'var(--textColorSecondary)',
                  textTransform: 'none',
                  fontSize: isReductScreen || collapsed ? 12 : 14
                }}
              >
                {`${user?.insurer?.name}`}
              </Typography.Text>
            </StyledHeaderWelcome>
            <StyledHeaderAvatar
              style={{
                display: isReductScreen || collapsed ? 'none' : 'block'
              }}
            >
              <Skeleton
                avatar={{ size: 'large' }}
                loading={isLogoLoading}
                paragraph={false}
                title={false}
              >
                <Avatar shape="circle" size={90} src={imageUrl} />
              </Skeleton>
            </StyledHeaderAvatar>
          </>
        )}
        <LogoutButton collapsed={collapsed} />
        <NavMenuSiderRight
          insurer={user?.insurer}
          path={path}
          setCollapsed={setCollapsed}
        />
        <Button
          type="link"
          onClick={() => setCollapsed(!collapsed)}
          icon={collapsed ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
          style={{
            width: collapsed ? 80 : 200,
            position: 'fixed',
            bottom: 0,
            color: 'var(--textColorSecondary)',
            borderTop: '1px solid rgba(249, 249, 249, 0.2)',
            borderRadius: 0,
            backgroundColor: 'var(--clientColor)'
          }}
        />
      </StyledSiderRight>
      <style jsx="true">
        {`
          .ant-avatar > img {
            object-fit: contain;
          }
        `}
      </style>
    </>
  );
};

RightSider.propTypes = {
  path: PropTypes.string.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired
};

export default RightSider;
